import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Homepage from 'pages/Homepage';
import CategoryPage from 'pages/CategoryPage';
import CheckoutPage from 'pages/CheckoutPage';
import ProductPage from 'pages/ProductPage';
import AddressesPage from 'pages/AddressesPage';
import LoginPage from 'pages/LoginPage';
import UserAccountPage from 'pages/UserAccountPage';

import './App.css';
import 'assets/css/styles.css';

class Page404 extends Component {
	render() {
		return (
			<div className="text-center not-found mt-5">
				<i className="fa fa-frown-o" aria-hidden="true" />
				<p>404</p>
				<p>Oops! Page not found</p>
			</div>
		);
	}
}

class App extends Component {
	render() {
		return (
			<Router>
				<Switch>
					<Route path="/" exact component={Homepage} />
					<Route path="/category/:id" exact component={CategoryPage} />
					<Route path="/checkout" exact component={CheckoutPage} />
					<Route path="/product/:productId" exact component={ProductPage} />
					<Route path="/addresses/:ardsId" exact component={AddressesPage} />
					<Route path="/login" exact component={LoginPage} />
					<Route path="/myaccount" exact component={UserAccountPage} />
					<Route component={Page404} />
				</Switch>
			</Router>
		);
	}
}
export default App;
